import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Stack, TableCell } from '@mui/material';

import { useSurveyList } from 'src/components/survey/SurveyContext/ListContext';
import type { CellProps } from 'src/components/survey/SurveySelectionPage/components/SurveyTableView/types';

import { styles } from './cell.styles';

const GoToSurvey: FC<CellProps> = ({ columns, survey }) => {
  const { t } = useTranslation('survey');
  const { selectSurvey } = useSurveyList();
  const handleOpenSurvey = () => selectSurvey(survey.id);
  const hasMyFollowUp = survey.accessibleModulePermissions.find(
    () => false, // disabled for now
    // ({ moduleType }) => moduleType === SECTION.MY_FOLLOW_UP,
  );

  return (
    <TableCell sx={styles.cell(columns.id.width)}>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: 'flex-end',
        }}
      >
        {hasMyFollowUp && (
          <Button variant="cta" color="secondary">
            Create Follow-Up
          </Button>
        )}
        <Button onClick={handleOpenSurvey}>{t('goToSurvey')}</Button>
      </Stack>
    </TableCell>
  );
};

export default GoToSurvey;
